import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Custom
import { openDialog } from 'actions';
import { getHocDisplayName } from 'utils/Tools';

const withConfirmDialog = (WrappedComponent, options = {}) => {
  const { withRef = false } = options;

  class WithConfirmDialog extends React.Component {
    constructor(props) {
      super(props);

      this.handleDisplayConfirm = this.handleDisplayConfirm.bind(this);
      this.handleConfirm = this.handleConfirm.bind(this);

      this.confirmCallback = null;
    }

    getWrappedInstance() {
      return withRef ? this.wrappedInstance : null;
    }

    // Handlers
    handleDisplayConfirm(message, confirmCallback, confirmOptions = {}, title) {
      // Store callback locally
      this.confirmCallback = confirmCallback;
      // Options
      const { confirmLabel = 'delete', additionalMessage } = confirmOptions;
      // Build message
      // message is {id, values}
      const initialMessage = <LocalizedMessage {...message} />;
      const finalMessage = additionalMessage
        ? (
          <React.Fragment>
            {initialMessage}
            <br />
            <br />
            {additionalMessage}
          </React.Fragment>
        ) : initialMessage;

      const { handleOpenDialog } = this.props;
      handleOpenDialog({
        ...title ? { title: { id: title } } : null,
        actions: [
          { type: 'cancel' },
          { type: 'validate', label: confirmLabel },
        ],
        component: {
          type: 'CONFIRM_MESSAGE',
          props: {
            message: finalMessage,
            onValidate: this.handleConfirm,
          },
        },
      });
    }

    handleConfirm() {
      if (this.confirmCallback) {
        this.confirmCallback();
        this.confirmCallback = null;
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          handleDisplayConfirm={this.handleDisplayConfirm}
          ref={withRef ? (wi) => { this.wrappedInstance = wi; } : null}
        />
      );
    }
  }

  WithConfirmDialog.displayName = getHocDisplayName('WithConfirmDialog', WrappedComponent);

  WithConfirmDialog.propTypes = {
    handleOpenDialog: PropTypes.func.isRequired,
  };

  const mapDispatchToProps = (dispatch) => ({
    handleOpenDialog: (props) => {
      dispatch(openDialog(props));
    },
  });

  return connect(
    null,
    mapDispatchToProps,
  )(WithConfirmDialog);
};

export default withConfirmDialog;



// WEBPACK FOOTER //
// ./hocs/WithConfirmDialog.js